export default __webpack_public_path__ + "a24981096849ca96a48e39fdb38eb9c7.png";